<!--易询宝询价单详情-->
<template>
    <div
        id="yxbInquiryDetail"
        class="business-content-main"
    >
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>询价管理</el-breadcrumb-item>
                <el-breadcrumb-item>询价单详情</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="section-title">
            <div>
                <span>订单信息&nbsp;&nbsp;{{InquiryDetail.ICode}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <div>
                <el-button
                    type="primary"
                    size="small"
                    class="search-btn btn-primary"
                    @click="quoteToCustomer(InquiryDetail.BillId)"
                    v-if="permission.报价&&InquiryDetail.State== 2&&!canEdit"
                >
                    报价
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    class="search-btn btn-primary"
                    v-if="permission.推送&&InquiryDetail.Intention>0&&!canEdit"
                    @click="submitPurchaseIntention(InquiryDetail.BillId)"
                >
                    推送
                </el-button>
                <el-button
                    type="primary"
                    size="small"
                    class="search-btn btn-primary"
                    v-if="permission.编辑&&canEdit&&type!=0"
                    @click="editCHJInquiryBill()"
                >
                    保存报价
                </el-button>
            </div>
        </div>
        <div class="section-content">
            <el-form
                :model="InquiryDetail"
                label-width="100px"
                class="padding-lf"
                ref="InquiryDetail"
            >
                <el-row :gutter="20">

                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="客户">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.CName"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="手机号">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.PhoneNum"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="状态">
                                <el-input
                                    disabled
                                    v-bind:value='InquiryDetail.State|StateHandle'
                                > </el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="询价时间">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.ITime"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="期限时间">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.NeedTime"
                                > </el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="报价时间">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.QTime"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="成本价">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.PriceSumCome"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="销售价">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.PriceSumSell"
                                > </el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="运费">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.PriceSumShip"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <div class="grid-content bg-purple">
                            <el-form-item label="客户要求">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.Remark"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
                <el-row
                    :gutter="20"
                    v-if="InquiryDetail.Intention>0"
                >
                    <el-col :span="6">
                        <div class="grid-content bg-purple">
                            <el-form-item label="客户意向">
                                <el-input
                                    disabled
                                    :value="InquiryDetail.Intention==1?'有意向':InquiryDetail.Intention==2?'无意向':'未定'"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col
                        :span="6"
                        v-if="InquiryDetail.Intention==2"
                    >
                        <div class="grid-content bg-purple">
                            <el-form-item label="无意向原因">
                                <el-input
                                    disabled
                                    v-model="InquiryDetail.NoIntentionReason"
                                ></el-input>
                            </el-form-item>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="section-title">
            <div>
                <span>订单明细</span>&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
        </div>
        <div class="section-content">
            <el-collapse
                v-model="activeNames"
                class="padding-lf"
            >
                <el-collapse-item
                    v-for="(item,index) in childBills"
                    :title="item.EntpName"
                    :name="index"
                    :key="index"
                >
                    <el-form
                        :model="item"
                        label-width="100px"
                    >
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="报价单号">
                                        <el-input
                                            disabled
                                            v-model="item.QCode"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="状态">
                                        <el-input
                                            disabled
                                            v-bind:value='item.State|ChildBillState'
                                        > </el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="报价时间">
                                        <el-input
                                            disabled
                                            v-model="item.QTime"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="6">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="成本价">
                                        <el-input
                                            disabled
                                            v-model="item.PriceSumCome"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="销售价">
                                        <el-input
                                            disabled
                                            v-model="item.PriceSumSell"
                                        > </el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="6">
                                <div class="grid-content bg-purple">
                                    <el-form-item label="运费">
                                        <el-input
                                            :disabled="!(permission.编辑&&canEdit&&type!=0&&item.EntpId=='')"
                                            v-model="item.PriceSumShip"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-table
                        :header-cell-style="{background:'#F2F6FC'}"
                        :data="item.goodsList"
                        border=""
                    >
                        <el-table-column
                            show-overflow-tooltip
                            prop="MainImg"
                            label="图片"
                            align="center"
                            width="90px"
                        >
                            <template
                                slot-scope="scope"
                                align="center"
                            >
                                <div
                                    v-viewer="options"
                                    v-if="scope.row.MainImg"
                                >
                                    <template>
                                        <img
                                            :src="scope.row.PreMainImg+'?imageView2/2/w/200'"
                                            class="formImg"
                                            :data-src="scope.row.PreMainImg"
                                        >
                                    </template>
                                </div>
                                <div v-else>
                                    <el-upload
                                        class="avatar-uploader"
                                        action="/"
                                        accept="image/*"
                                        :limit="1"
                                        :data="uploadData"
                                        :show-file-list="false"
                                        :http-request="(file)=>{return upLoad(file,index,scope.row)}"
                                    >
                                        <img
                                            v-if="scope.row.MainImg"
                                            :src="scope.row.PreMainImg"
                                            class="formImg"
                                        >
                                        <i
                                            v-else-if="type!=0"
                                            class="el-icon-plus avatar-uploader-icon"
                                            style="font-size:28px;"
                                        ></i>
                                    </el-upload>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            prop="APCode"
                            label="配件编码"
                        ></el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            prop="GoodsName"
                            label="配件名称"
                        ></el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            prop="AutoSerise"
                            label="车型"
                        ></el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            prop="Count"
                            label="数量"
                            width="90px"
                        ></el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            prop="Unit"
                            label="单位"
                            width="90px"
                        ></el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            prop="CostPrice"
                            label="进货价"
                        >
                            <template slot-scope="scope">
                                <el-input
                                    size="small"
                                    min="0"
                                    type="number"
                                    step="0.01"
                                    v-model="scope.row.CostPrice"
                                    v-if="permission.编辑&&canEdit&&type!=0&&item.EntpId==''"
                                ></el-input>
                                <span v-else>{{scope.row.CostPrice}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            prop="MarketPrice"
                            label="销售价"
                        >
                            <template slot-scope="scope">
                                <el-input
                                    size="small"
                                    min="0"
                                    type="number"
                                    step="0.01"
                                    v-model="scope.row.MarketPrice"
                                    v-if="permission.编辑&&canEdit&&type!=0&&item.EntpId==''"
                                ></el-input>
                                <span v-else>{{scope.row.MarketPrice}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            show-overflow-tooltip
                            prop="Remark"
                            label="备注"
                        ></el-table-column>
                    </el-table>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
Vue.use(Viewer);
export default {
  name: "yxbInquiryDetail",
  components: {},
  data() {
    return {
      imgcdn: this.$util.QN_URL_BASE,
      billId: "",
      type: 0, //0查看，1编辑
      activeNames: [0],
      InquiryDetail: {},
      childBills: [],
      permission: {},
      canEdit: false,
      options: {
        url: "data-src",
        zIndex: 9999
      },
      uploadData: {
        key: "AutoParts",
        isPrivate: false
      }
    };
  },
  filters: {
    StateHandle(value) {
      let result = "";
      switch (value) {
        case 0:
          result = "已提交";
          break;
        case 1:
          result = "已分发";
          break;
        case 2:
          result = "企业已报价";
          break;
        case 3:
          result = "已报价给客户";
          break;
        case 4:
          result = "已确认客户意向";
          break;
        case 5:
          result = "已作废";
          break;
        default:
          result = "未知";
          break;
      }
      return result;
    },
    ChildBillState(value) {
      let result = "";
      switch (value) {
        case 0:
          result = "未报价";
          break;
        case 1:
          result = "已报价";
          break;
        case 2:
          result = "已转为订单";
          break;
        case 3:
          result = "已作废";
          break;
        case 4:
          result = "已删除";
          break;
        default:
          result = "未知";
          break;
      }
      return result;
    }
  },
  mounted() {
    this.$util.getPermission("易询宝询价单").then(res => {
      this.permission = res;
    });

    this.billId = this.$route.query.billId;
    this.type = this.$route.query.type;

    this.getInquiryBillDetail();
  },
  methods: {
    upLoad(file, index, row) {
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("key", "AutoParts");
      formData.append("isPrivate", false);
      let that = this;
      row.MainImg = "";
      that.axios
        .post("/Common/UploadSingle", formData)
        .then(res => {
          let result = res.data;
          if (result && result.errcode == 0) {
            row.PreMainImg = that.imgcdn + result.fileUrl;
            row.MainImg = result.fileUrl;
          } else {
            that.$util.warningMsg(result.errmsg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getInquiryBillDetail() {
      let that = this;
      this.axios
        .get("/YXBInquiryBill/GetInquiryBillDetail?billId=" + that.billId)
        .then(response => {
          if (response.data.errcode == 0 && response.data.data) {
            that.InquiryDetail = response.data.data.billModel;
            that.childBills = response.data.data.entpList;
            for (let i = 0; i < that.childBills.length; i++) {
              let goodsList = that.childBills[i].goodsList;
              goodsList.forEach(e => {
                if (e.MainImg) {
                  e.PreMainImg = that.imgcdn + e.MainImg;
                }
              });
            }
            that.canEdit = response.data.data.canEdit;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    editCHJInquiryBill() {
      let that = this;
      let reqData = {
        BillId: that.billId,
        CHJBillId: "",
        PriceSumShip: 0,
        GoodsList: []
      };
      let filterBill = that.childBills.filter(e => e.EntpId == "");
      if (!filterBill || filterBill.length == 0) {
        that.$util.warningMsg("没有可编辑的子订单");
        return;
      }
      let chjbill = filterBill[0];
      if (chjbill) {
        reqData.CHJBillId = chjbill.EntpBillId;
        reqData.PriceSumShip = Number(chjbill.PriceSumShip);
        let goodsList = chjbill.goodsList;
        for (let i = 0; i < goodsList.length; i++) {
          let CostPrice = Number(goodsList[i].CostPrice);
          if (CostPrice <= 0) {
            that.$util.warningMsg("进货价不能小于等于零");
            return;
          }
          let MarketPrice = Number(goodsList[i].MarketPrice);
          if (MarketPrice <= 0) {
            that.$util.warningMsg("销售价不能小于等于零");
            return;
          }
          reqData.GoodsList.push({
            GoodsId: goodsList[i].GoodsId,
            GoodsName: goodsList[i].GoodsName,
            CostPrice: CostPrice,
            MarketPrice: MarketPrice,
            MainImg: goodsList[i].MainImg
          });
        }
      }

      that.axios
        .post("/YXBInquiryBill/EditCHJInquiryBill", reqData)
        .then(resp => {
          let result = resp.data;
          if (result && result.errcode == 0) {
            that.getInquiryBillDetail();
            that.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            that.$util.errorMsg(result.errmsg);
          }
        })
        .catch(error => {
          that.$message.error(error);
        });
    },
    quoteToCustomer() {
      let that = this;
      this.$util.elConfirm({
        that: this,
        content: "确定要报价给客户?",
        confirm() {
          that.axios
            .post("/YXBInquiryBill/QuoteToCustomer?billId=" + that.billId)
            .then(response => {
              let result = response.data;
              if (result && result.errcode == 0) {
                that.InquiryDetail.State = 3;
                that.$message({
                  message: "报价成功",
                  type: "success"
                });
              }
            })
            .catch(error => {
              console.log(error);
              that.$message.error(error.data.errmsg);
            });
        }
      });
    },
    submitPurchaseIntention() {
      let that = this;
      this.$util.elConfirm({
        that: this,
        content: "确定要推送客户的购买意向给企业?",
        confirm() {
          that.axios
            .post(
              "/YXBInquiryBill/SubmitPurchaseIntention?billId=" + that.billId
            )
            .then(response => {
              let result = response.data;
              if (result && result.errcode == 0) {
                that.$message({
                  message: "推送成功",
                  type: "success"
                });
              }
            })
            .catch(error => {
              console.log(error);
              that.$message.error(error.data.errmsg);
            });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}
.section-content {
  border: 1px solid @border3Color;
  padding-top: 20px;
  margin-bottom: 20px;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.padding-lf {
  padding-right: 30px !important;
  padding-left: 30px !important;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.el-collapse-item__header {
  font-weight: bold !important;
  font-size: 16px !important;
}
.formImg {
  cursor: pointer;
  width: 70px;
  height: 70px;
}
</style>
<style lang="less">
input {
  cursor: default !important;
}
.el-collapse-item__header {
  font-weight: bold !important;
  font-size: 16px !important;
}
</style>

